import {Component, OnInit} from '@angular/core';
import {DancerDto} from 'src/app/services/dancer.service';
import {Validators} from '@angular/forms';
import {FormBuilder} from '@angular/forms';
import {ShoppingCartService, Ticket} from 'src/app/services/shopping-cart.service';
import * as _ from 'lodash';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  dancerModal = false;
  dancerForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    mobileNumber: ['', Validators.required],
    personalNumber: ['', Validators.required],
    email: ['', Validators.required],
    danceLike: ['', Validators.required],
    homeAddress: ['', Validators.required],
    comments:  '',
  });
  private currentTicket: Ticket;
  private creatingDancer: boolean;
  editingIndex = '';
  dancers: any;

  constructor(private fb: FormBuilder, public cart: ShoppingCartService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    console.log('init');
  }

  saveDancer() {
    console.log('dancer saved');
    // console.log(this.dancerForm.value);
    this.dancerModal = false;
    const dancer: DancerDto = this.dancerForm.value;
    let dancerId;

    if (this.editingIndex) {
      dancerId = this.editingIndex;
      this.cart.saveDancer([this.editingIndex, dancer]);
    } else {
      dancerId = this.cart.addDancer(dancer);
    }

    console.log('dancer is ');
    console.dir(dancer);
    if (this.currentTicket != null) {
      this.cart.setDancerFor(this.currentTicket, dancerId);
    }
    this.cancelEdit();
    this.cart.saveBasket();
  }

  get tickets(): Ticket[] {
    return this.cart.tickets;
  }

  removeDancer(dancerId: string) {
    this.cart.removeDancer(dancerId);
  }

  readyToCheckout(): boolean {
    if (this.cart.tickets.length === 0) {
      return false;
    }
    if (this.cart.dancers.length === 0) {
      return false;
    }
    for (const ticket of this.cart.tickets) {
      if (ticket.dancerId === null || ticket.dancerId === '' || ticket.dancerId === undefined) {
        return false;
      }
    }
    return true;
  }

  removeTicket(ticket: Ticket) {
    // already initiated payson payment should not be valid anymore
    this.cart.priceChangedInbasket.emit(true);

    _.remove(this.cart.tickets, t => t === ticket);
    this.cart.saveBasket();
  }

  editDancer(dancerId: string) {
    this.dancerForm.setValue(this.cart.getDancer(dancerId));
    this.editingIndex = dancerId;
    this.dancerModal = true;
    this.currentTicket = null;
  }

  onChange(index, selectBox) {
    this.currentTicket = this.tickets[index];
    // console.log(this.currentTicket);
    // console.log(selectBox);
    const option = selectBox.options[selectBox.selectedIndex];

    const newDancer = option.attributes['newDancer'];
    if (newDancer != null) {
      this.addNewDancer();
    } else {
    }
    this.cart.saveBasket();
  }

  public addNewDancer(): void {
    this.dancerForm.setValue(this.newDancer());
    this.dancerModal = true;
    this.editingIndex = '';
    this.creatingDancer = true;
  }

  cancelEdit(): void {
    this.creatingDancer = false;
    this.editingIndex = '';
    this.dancerModal = false;
    this.currentTicket = null;
  }

  newDancer(): DancerDto {
    return {
      firstName: '',
      lastName: '',
      personalNumber: '',
      homeAddress: '',
      email: '',
      mobileNumber: '',
      danceLike: 'Man',
      comments: '',
    };
  }

  selectPayment() {
    this.cart.saveBasket();
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigate([
      this.route.snapshot.params['username'], 'payment'
    ]);
  }

}


